/**
 * One entry point for AP-731's cascade from the editor hooks (§1). Every
 * reader action that writes a measurement goes through here, naming the rows it
 * wrote and which of the three actions it was; nothing else may call the engine.
 */

import type { Measurement, Report as MReport } from '@/models/report';
import type { MeasurementGroup } from '@/models/template';
import {
  applyCascade,
  type CascadeAction,
} from '@/features/report/derived/applyCascade';

interface RunCascadeArgs {
  /** The report as it was before the action — the divergence snapshot. */
  report: MReport;
  /** Measurements with the reader's own change already applied. */
  updated: Measurement[];
  /** canonicalMeasurement(s) the action wrote directly. */
  target: string | string[];
  action: CascadeAction;
  measurementGroups?: MeasurementGroup[];
  patientSex?: string | null;
}

export function runCascade({
  report,
  updated,
  target,
  action,
  measurementGroups,
  patientSex,
}: RunCascadeArgs): Measurement[] {
  if (!measurementGroups?.length) return updated;
  return applyCascade({
    before: report.measurements,
    after: updated,
    measurementGroups,
    aiMeasurements: report.aiMeasurements ?? [],
    sex: patientSex,
    target,
    action,
  });
}
